import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentContainer } from '../../components/custom_components/ContentContainer'
import { PerInfoBox } from '../../components/custom_components/InfoBox'
import { InfoBoxTile } from '../../components/custom_components/InfoBox/InfoBoxTileTemplate/InfoBoxTile'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import PerText from '../../components/custom_components/Text'
import { CompanySettingsContent } from './CompanySettingsContent'
import { CompanySettingsHeader } from './CompanySettingsHeader'
import { useCompanySettingsStore } from './CompanySettingsStore'
import './index.less'
import { useAuth } from '../../context/auth-context'
import { useCompaniesOfNetworkOrCompanyManagerOrHRBP } from '../../graphql/company/hooks/useCompaniesOfNetworkOrCompanyManager'

export const CompanySettingsManagerView: FC<{ collapsed?: boolean }> = ({ collapsed }) => {
  const { t } = useTranslation()
  const { user } = useAuth()

  const [initStore, storeInitialized] = useCompanySettingsStore((state) => [state.initStore, state.storeInitialized])

  const { data, error, loading } = useCompaniesOfNetworkOrCompanyManagerOrHRBP()

  useEffect(() => {
    if (
      !!data &&
      !!data.findCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP &&
      !!data.findCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP.length
    ) {
      initStore(data.findCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP)
    }
  }, [data, initStore, user.roles])

  if (
    loading ||
    error ||
    !data ||
    !data.findCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP ||
    (!!data.findCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP.length && !storeInitialized)
  ) {
    return (
      <ContentContainer collapsed={collapsed}>
        <LoadingAndErrors
          isLoading={true}
          hasNoData={!data || !data.findCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP}
          error={error}
          showSpinner
        />
      </ContentContainer>
    )
  } else if (!!data && !data.findCompaniesAndCountriesByNetworkOrCompanyManagerOrHRBP.length) {
    return (
      <PerInfoBox>
        <InfoBoxTile
          heading={t('companySettingsView.empty.heading')}
          headingAlign="center"
          contentAlign="center"
          headingColor="secondary"
          headingMt="xl"
        >
          <PerText>{t('companySettingsView.empty.message')}</PerText>
        </InfoBoxTile>
      </PerInfoBox>
    )
  }

  return (
    <ContentContainer>
      <CompanySettingsHeader />
      <CompanySettingsContent />
    </ContentContainer>
  )
}
